import { useAppLogo } from "helpers/useAppSetting";
import { CHECK_DISPLAY_CLS } from "../pifStyles";
import { formatDate } from "helpers/utils";
import { Link } from "react-router-dom";
import React from 'react';
import PropTypes from 'prop-types';

const GDS = ({pif}) => {
  const logo = useAppLogo();
  const {project, building, adaptation} = pif;
  const gds = pif?.gds || {};
  const paintSystemData = gds?.paint_systems || [];
  const secondaryMemberData = gds?.secondary_members || [];

  const projectUrl = `/crm/projects/${project?.id}`;

  return (
    <table className="tw-text-sm">
      <tr>
        <td colSpan="2" className="tw-text-left tw-font-bold">
          General Data Sheet (GDS) 1
        </td>
        <td colSpan="6" className="tw-text-center">
          <div className="tw-text-2xl tw-font-bold tw-mb-2">PROJECT INFORMATION FORM</div>
        </td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          GDS Page: 1 of 1
        </td>
      </tr>
      <tr>
        <td colSpan="2" rowSpan="2" className="tw-text-center">
          <img
            src={logo}
            alt="Logo Pebsteel"
            width="160"
            height="60"
            className="tw-object-contain tw-rounded-sm"
            style={{maxWidth: '100%'}}
          />
        </td>
        <td className="tw-font-bold">Quote No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{project?.q_number}</Link>
        </td>
        <td className="tw-font-bold">Rev No:</td>
        <td className="tw-text-primary-600">{adaptation.rev}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <div className="tw-flex tw-justify-around">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_order_entry"
                checked={!!(adaptation?.type === "change_order")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Order Entry</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                name="for_quotation"
                checked={!!(adaptation?.type === "revision")}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>For Quotation</span>
            </label>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-font-bold">P/Job No:</td>
        <td className="tw-text-primary-600">
          <Link to={projectUrl}>{building?.j_number}</Link>
        </td>
        <td className="tw-font-bold">CO#:</td>
        <td className="tw-text-primary-600">{adaptation.co}</td>
        <td className="tw-font-bold">Date:</td>
        <td className="tw-text-primary-600">{formatDate(adaptation.entry_date)}</td>
        <td colSpan="2" className="tw-text-right tw-font-bold">
          <h6 className="tw-text-center tw-my-2">This sheet is applicable to entire project</h6>
        </td>
      </tr>
      <tr>
        <td rowSpan="2" className="tw-text-center">1</td>
        <td className="tw-font-bold tw-text-center" rowSpan="2">GENERAL INFORMATION</td>
        <td>Project Name:</td>
        <td colSpan="5" className="tw-font-bold tw-text-primary-600">{project?.name}</td>
        <td colSpan="2">
          <div className="tw-flex tw-justify-between">
            <span>No of all Bldgs in this Project:</span>
            <span className="tw-text-primary-600 tw-font-bold tw-mr-4">{gds?.no_of_bldgs}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>Location:</td>
        <td colSpan="5" className="tw-font-bold tw-text-primary-600">{building?.pj_location}</td>
        <td colSpan="2">
          <div className="tw-flex tw-justify-between">
            <span>No. of Non Identical Bldgs in this Project:</span>
            <span className="tw-text-primary-600 tw-font-bold tw-mr-4">{gds?.no_of_non_identical_bldgs}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">2</td>
        <td className="tw-font-bold tw-text-center">CURRENT CONTRACT STATUS</td>
        <td colSpan="8">
          <div className="tw-m-2">
            <div className="tw-grid tw-grid-cols-12 tw-gap-2">
              <div className="tw-col-span-6">
                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds?.contract_loi)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Letter of intent issued by customer on (Date)</span>
                </label>
              </div>
              <div className="tw-col-span-6">
                <span className="tw-text-primary-600">{formatDate(gds?.contract_loi_on_date)}</span>
              </div>
            </div>
            <div className="tw-grid tw-grid-cols-12 tw-gap-2">
              <div className="tw-col-span-6">
                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds?.peb_standard_offer_signed)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>PEB Standard Offer signed by customer on (Date)</span>
                </label>
              </div>
              <div className="tw-col-span-6">
                <span className="tw-text-primary-600">{formatDate(gds?.peb_standard_offer_signed_date)}</span>
              </div>
            </div>
            <div className="tw-grid tw-grid-cols-12 tw-gap-2">
              <div className="tw-col-span-6">
                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds?.customer_contract_signed)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Customer contract signed by customer on (Date)</span>
                </label>
              </div>
              <div className="tw-col-span-6">
                <span className="tw-text-primary-600">{formatDate(gds?.customer_contract_signed_date)}</span>
              </div>
            </div>
            <div className="tw-grid tw-grid-cols-12 tw-gap-2">
              <div className="tw-col-span-6">
                <label className="tw-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds?.contract_status_others)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Others (Explain)</span>
                </label>
              </div>
              <div className="tw-col-span-6">
                <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds?.contract_status_others_explain }}></span>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td width="2%" className="tw-text-center">3</td>
        <td className="tw-font-bold tw-text-center" width="18%">PENALTY</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              Terms of penalty
            </div>
            <div className="tw-col-span-8">
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds?.term_of_penalty }}></span>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2 tw-mt-3">
            <div className="tw-col-span-3">
              Max. Penalty as % of Contract Price:
            </div>
            <div className="tw-col-span-3">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds?.penalty_of_contact_price_5_percent)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>5%</span>
              </label>
            </div>
            <div className="tw-col-span-6">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds?.penalty_of_contact_price_other)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Others (Specify)</span>
              </label>
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds?.penalty_of_contact_price_other_specify }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">4</td>
        <td className="tw-font-bold tw-text-center">SHIPMENT</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              Delivery Commitment (weeks):
            </div>
            <div className="tw-col-span-8">
              <span className="tw-text-primary-600">{gds?.shipment_delivery_commitment}</span>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              Delivery by:
            </div>
            <div className="tw-col-span-8">
              <div className="tw-flex tw-justify-between">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds?.shipment_delivery_by_pebsteel)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>by PEB Steel</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds?.shipment_customer_pickup)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Customer pickup</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds.shipment_partial_allow)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Partial shipment allowed</span>
                </label>

              </div>
            </div>
          </div>

          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-6">
              <div className="tw-grid tw-grid-cols-12 tw-gap-0">
                <div className="tw-col-span-3">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.overland_to)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Overland to</span>
                  </label>
                </div>
                <div className="tw-col-span-9">
                  <span className="tw-text-primary-600">{gds.shipment_overland_to}</span>
                </div>
              </div>
            </div>
            <div className="tw-col-span-6">
              <div className="tw-grid tw-grid-cols-12 tw-gap-0">
                <div className="tw-col-span-3">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.seafreight_to)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Seafreight to</span>
                  </label>
                </div>
                <div className="tw-col-span-9">
                  <span className="tw-text-primary-600">{gds.shipment_seafreight_to}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-6">
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.shipment_seafreight)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Seafreight</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.shipment_container)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Container</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.shipment_truck)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Truck</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="tw-col-span-6">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2">
                <div className="tw-col-span-4">
                  Export document by:
                </div>
                <div className="tw-col-span-8">
                  <div className="tw-grid tw-grid-cols-12 tw-gap-2">
                    <div className="tw-col-span-4">
                      <label className="tw-flex tw-items-center tw-gap-2">
                        <input
                          type="checkbox"
                          checked={!!(gds.shipment_export_document_by_pebsteel)}
                          readOnly
                          className={CHECK_DISPLAY_CLS}
                        />
                        <span>PEB Steel</span>
                      </label>
                    </div>
                    <div className="tw-col-span-8">
                      <label className="tw-flex tw-items-center tw-gap-2">
                        <input
                          type="checkbox"
                          checked={!!(gds.shipment_export_document_by_others)}
                          readOnly
                          className={CHECK_DISPLAY_CLS}
                        />
                        <span>by others</span>
                      </label>

                      <span className="tw-text-primary-600">{gds.shipment_export_document_by_others_specify}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">5</td>
        <td className="tw-font-bold tw-text-center">REQUIRED INITIAL ENGINEERING SUBMITTALS</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.eng_design_calculation)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Design calculation</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.eng_approval_drawings)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Approval drawings</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.eng_erection_drawings)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Erection drawings</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.end_preliminary_design_sheet)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Preliminary Design Sheet</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.eng_anchor_bolts_plan)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Anchor Bolts Plan</span>
              </label>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">6</td>
        <td className="tw-font-bold tw-text-center">ANCHOR BOLTS</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              Anchor Bolts by:
            </div>
            <div className="tw-col-span-8">
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.anchor_bolts_by_pebsteel)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>PEB Steel</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.anchor_bolts_by_other)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>by others</span>
                  </label>

                  <div className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds.anchor_bolts_by_other_specify }}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mt-3">
            <div className="tw-col-span-6">
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">Ship Anchor Bolts:</div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.anchor_bolts_ship_with_job)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>with Job</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.anchor_bolts_priod_to_job)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Priod to Job</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="tw-col-span-6">
              <div className="tw-flex tw-gap-2">
                <div className="tw-flex-1">Ship by:</div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.anchor_bolts_ship_by_overland)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Overland</span>
                  </label>
                </div>
                <div className="tw-flex-1">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.anchor_bolts_ship_by_seafreight)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>Seafreight</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <div className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds.anchor_bolts_note }}></div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">7</td>
        <td className="tw-font-bold tw-text-center">BUYER (Invoice To)</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Name:</div>
                <div className="tw-col-span-10 tw-text-primary-600">

                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Phone:</div>
                <div className="tw-col-span-10 tw-text-primary-600"></div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-3">Address:</div>
                <div className="tw-col-span-9 tw-text-primary-600"></div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Contact person:</div>
                <div className="tw-col-span-10 tw-text-primary-600"></div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Email:</div>
                <div className="tw-col-span-10 tw-text-primary-600"></div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Fax:</div>
                <div className="tw-col-span-10 tw-text-primary-600"></div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Title:</div>
                <div className="tw-col-span-10 tw-text-primary-600"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">8</td>
        <td className="tw-font-bold tw-text-center">CONSIGNEE (Ship To)</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Name:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.consignee_name}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Phone:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.consignee_phone}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Address:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.consignee_address}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Mobile:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.consignee_mobile}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Fax:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.consignee_fax}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Email:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.consignee_email}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">9</td>
        <td className="tw-font-bold tw-text-center">SHIPMENT (Advice To)</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Name:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.shipment_advice_to_name}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Fax:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.shipment_advice_to_fax}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Mobile:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.shipment_advice_to_mobile}</span>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
                <div className="tw-col-span-2">Email:</div>
                <div className="tw-col-span-10">
                  <span className="tw-text-primary-600">{gds.shipment_advice_to_email}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">10</td>
        <td className="tw-font-bold tw-text-center">CONSULTANT</td>
        <td colSpan="8">

        </td>
      </tr>
      <tr>
        <td className="tw-text-center">11</td>
        <td className="tw-font-bold tw-text-center">CONTRACTOR</td>
        <td colSpan="8">
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">12</td>
        <td className="tw-font-bold tw-text-center">ENDUSER</td>
        <td colSpan="8">

        </td>
      </tr>
      <tr>
        <td className="tw-text-center">13</td>
        <td className="tw-font-bold tw-text-center">ERECTION</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mb-2">
            <div className="tw-col-span-4">
              Erection by:
            </div>
            <div className="tw-col-span-8">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2">
                <div className="tw-col-span-3">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.erection_by_pebsteel)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>PEB Steel</span>
                  </label>
                </div>
                <div className="tw-col-span-3">
                  <label className="tw-flex tw-items-center tw-gap-2">
                    <input
                      type="checkbox"
                      checked={!!(gds.erection_by_others)}
                      readOnly
                      className={CHECK_DISPLAY_CLS}
                    />
                    <span>by others</span>
                  </label>
                </div>
                <div className="tw-col-span-6">
                  <div className="tw-flex tw-gap-2">
                    <div>
                      Erector Name:
                    </div>
                    <div className="tw-flex-1">
                      <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds.erector_name }}></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mb-1">
            <div className="tw-flex-1">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.erection_supervisor_by_peb)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Erection supervisior by PEB</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2">
                <div>
                  Explain details:
                </div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds.erection_explain_detail }}></span>
                </div>
              </div>
              <div className="tw-flex tw-gap-2">
                <div>
                  Note:
                </div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds.erection_note }}></span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">14</td>
        <td className="tw-font-bold tw-text-center">PRIMARY MEMBERS</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div>
              Surface treatment:
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-justify-between">
                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds.primary_power_clean_st3)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Power clean ST3</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds.primary_shotblasting_sa_2_0)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Shotblasting SA 2.0</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds.primary_shotblasting_sa_2_5)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>Shotblasting SA 2.5</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds.primary_hd_galv)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>H.D.Galv</span>
                </label>

                <label className="tw-inline-flex tw-items-center tw-gap-2">
                  <input
                    type="checkbox"
                    checked={!!(gds.primary_dft)}
                    readOnly
                    className={CHECK_DISPLAY_CLS}
                  />
                  <span>DFT</span>
                </label>
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <div className="tw-flex">
                <div className="tw-mr-3">Purlin Clip to Column / Rafter:</div>
                <input
                  type="checkbox"
                  checked={!!(gds.primary_purlin_clip_to_column)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
              </div>
            </div>
          </div>
          <div className="tw-flex tw-gap-2 tw-mt-2">
            <div className="tw-flex-1">
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds.primary_memebers_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">15</td>
        <td className="tw-font-bold tw-text-center">PAINT SYSTEM</td>
        <td colSpan="8">
          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table>
              <thead className="tw-bg-slate-200 tw-text-slate-900">
                <tr>
                  <th className="tw-border">Coat No.</th>
                  <th className="tw-border">DFT (microns)</th>
                  <th className="tw-border">Paint Type</th>
                  <th className="tw-border">Manufacturer</th>
                  <th className="tw-border">Color</th>
                </tr>
              </thead>
              <tbody>
                {paintSystemData && paintSystemData.map((item, index) => (
                  <tr key={index}>
                    <td className="tw-border">{item.cost_no}</td>
                    <td className="tw-border">{item.dft}</td>
                    <td className="tw-border">{item.paint_type}</td>
                    <td className="tw-border">{item.manufacturer}</td>
                    <td className="tw-border">{item.color}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-flex tw-gap-2 tw-mt-2">
            <div className="tw-flex-1">
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds?.paint_system_note }}></span>
            </div>
          </div>

        </td>
      </tr>
      <tr>
        <td className="tw-text-center">16</td>
        <td className="tw-font-bold tw-text-center">SECONDARY MEMBERS <br/> (Purlins, girts, eave strut)</td>
        <td colSpan="8">
          <div className="tw-grid tw-grid-cols-12 tw-gap-2">
            <div className="tw-col-span-3">
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.second_galv)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Galv.</span>
              </label>
            </div>
            <div className="tw-col-span-9">
              <div className="tw-grid tw-grid-cols-12 tw-gap-2">
                <div className="tw-col-span-3 tw-font-semibold">
                  Surface treatment:
                </div>
                <div className="tw-col-span-9">
                  <div className="tw-flex tw-justify-between">
                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(gds.second_power_clean_st3)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Power clean ST3</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(gds.second_shotblasting_sa_2_0)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Shotblasting SA 2.0</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(gds.second_shotblasting_sa_2_5)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Shotblasting SA 2.5</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-mt-2">
                <div className="tw-col-span-3 tw-font-semibold">
                  Paint system:
                </div>
                <div className="tw-col-span-9">
                  <div className="tw-flex tw-justify-between">
                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(gds.second_paint_standard)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Standard Alkyd red oxide primer</span>
                    </label>

                    <label className="tw-inline-flex tw-items-center tw-gap-2">
                      <input
                        type="checkbox"
                        checked={!!(gds.second_paint_speical)}
                        readOnly
                        className={CHECK_DISPLAY_CLS}
                      />
                      <span>Special (see below)</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tw-overflow-x-auto tw-text-sm tw-mt-2">
            <table>
              <thead className="tw-bg-slate-200 tw-text-slate-900">
                <tr>
                  <th className="tw-border">Coat No.</th>
                  <th className="tw-border">DFT (microns)</th>
                  <th className="tw-border">Paint Type</th>
                  <th className="tw-border">Manufacturer</th>
                  <th className="tw-border">Color</th>
                </tr>
              </thead>
              <tbody>
                {secondaryMemberData && secondaryMemberData.map((item, index) => (
                  <tr key={index}>
                    <td className="tw-border">{item.cost_no}</td>
                    <td className="tw-border">{item.dft}</td>
                    <td className="tw-border">{item.paint_type}</td>
                    <td className="tw-border">{item.manufacturer}</td>
                    <td className="tw-border">{item.color}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-flex tw-gap-2 tw-mt-2">
            <div className="tw-flex-1">
              <span className="tw-text-primary-600" dangerouslySetInnerHTML={{ __html: gds?.secondary_memeber_note }}></span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">17</td>
        <td className="tw-font-bold tw-text-center">ATTACHED</td>
        <td colSpan="8">
          <div className="tw-flex tw-justify-between tw-mx-4">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.attached_gds)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>GDS</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.attached_bds1)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>BDS1</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.attached_bds2)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>BDS2</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.attached_bds3)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>BDS3</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.attached_sketchs)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Sketchs</span>
            </label>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">18</td>
        <td className="tw-font-bold tw-text-center">CHECKING</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Filled by:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{gds.filled_by}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Checked by:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{gds.checked_by}</span>
                </div>
              </div>
            </div>
            <div className="tw-flex-1">
              <div className="tw-flex tw-gap-2 tw-items-center">
                <div>Date:</div>
                <div className="tw-flex-1">
                  <span className="tw-text-primary-600">{formatDate(gds.checked_date)}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td className="tw-text-center">19</td>
        <td className="tw-font-bold tw-text-center">DOUBLE SIDE WELDING - WELDING - UT TEST - THIRD PART INPSECTION</td>
        <td colSpan="8">
          <div className="tw-flex tw-gap-2">
            <div>
              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.double_side_welding)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Double Side Welding</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.ut_test)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>UT Test</span>
              </label>

              <label className="tw-flex tw-items-center tw-gap-2">
                <input
                  type="checkbox"
                  checked={!!(gds.third_party_inspection)}
                  readOnly
                  className={CHECK_DISPLAY_CLS}
                />
                <span>Third Party Inspection</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <span className="tw-text-primary-600">{gds.double_side_welding_notes}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan="10">
          <div className="tw-flex tw-justify-around tw-mt-3">
            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.engineering)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Engineering</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.sales_support_dept)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Sales Support Dept,</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.sales_dept)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Sales Dept,</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.customer_service_dept)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Customer Service Dept,</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.production)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Production,</span>
            </label>

            <label className="tw-inline-flex tw-items-center tw-gap-2">
              <input
                type="checkbox"
                checked={!!(gds.finance)}
                readOnly
                className={CHECK_DISPLAY_CLS}
              />
              <span>Finance,</span>
            </label>
          </div>
        </td>
      </tr>
    </table>
  )
};

GDS.propTypes = {
  pif: PropTypes.object.isRequired
}

export default GDS;
